import React from "react";
import { useGlobalState } from "./useGlobalState";
import { Context } from "./Context";

export const StateProvider = ({ children, user }) => {
    const store = useGlobalState(user);

    return <Context.Provider value={store}>{children}</Context.Provider>;
};